/* eslint-disable react/jsx-props-no-spreading */
import * as React from "react";

const ApnaViLogo = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={109}
		height={87}
		fill="none"
		{...props}
	>
		<path
			fill="#E72938"
			d="M29.336 23.717h-.44v1.255h-.313v-1.255h-.44v-.251h1.193v.25Zm1.848-.251v1.506h-.275v-.988l.007-.067-.432.817a.116.116 0 0 1-.108.068h-.043a.123.123 0 0 1-.065-.017.123.123 0 0 1-.044-.051l-.433-.82c.003.044.005.089.006.133v.925h-.274v-1.506h.271c.011.002.02.003.028.007a.052.052 0 0 1 .021.014.1.1 0 0 1 .02.027l.422.804c.026.05.05.1.069.153l.032-.08.037-.076.42-.8a.098.098 0 0 1 .02-.028.06.06 0 0 1 .021-.014.087.087 0 0 1 .026-.006l.037-.001h.237Z"
		/>
		<path
			fill="#E72938"
			fillRule="evenodd"
			d="M21.118 39.77h5.832V23.422h-5.832V39.77Zm-7.736-16.348L9.607 38.654 5.832 23.422H0l4.051 16.346h11.112l4.05-16.346h-5.83Z"
			clipRule="evenodd"
		/>
		<path
			fill="#FFC600"
			fillRule="evenodd"
			d="M27.209 44.835A3.17 3.17 0 0 1 24.034 48a3.17 3.17 0 0 1-3.174-3.165 3.172 3.172 0 0 1 4.388-2.928 3.17 3.17 0 0 1 1.96 2.928Z"
			clipRule="evenodd"
		/>
		<path stroke="#E8E7EA" d="M41.184 24v24" />
		<g filter="url(#a)">
			<path
				fill="#fff"
				fillRule="evenodd"
				d="M57 19h17.369a5.815 5.815 0 0 1 5.815 5.815v17.37A5.815 5.815 0 0 1 74.37 48h-17.37a5.815 5.815 0 0 1-5.815-5.815v-17.37A5.815 5.815 0 0 1 57 19Z"
				clipRule="evenodd"
			/>
			<path
				fill="#FFD166"
				fillRule="evenodd"
				d="M79.758 44.375A5.817 5.817 0 0 1 74.372 48h-3.855v-3.625h9.24Z"
				clipRule="evenodd"
			/>
			<path
				fill="#2BB793"
				fillRule="evenodd"
				d="M56.996 48a5.817 5.817 0 0 1-5.385-3.625h9.24V48h-3.855Z"
				clipRule="evenodd"
			/>
			<path fill="#83BDE4" d="M60.851 44.375h9.667V48h-9.667z" />
			<path
				fill="#4D3951"
				fillRule="evenodd"
				d="M65.13 31.466c-.352-.524-.874-.786-1.565-.786a2.033 2.033 0 0 0-1.581.754l-.084-.544h-1.843v7.97l2.073-.21v-2.513c.335.37.768.555 1.299.555.44 0 .829-.131 1.167-.393.339-.262.6-.621.786-1.079.185-.457.277-.975.277-1.555 0-.942-.176-1.675-.529-2.199Zm-6.006 3.204c0 .196.025.34.074.435a.47.47 0 0 0 .261.215l-.418 1.33c-.377-.028-.685-.1-.922-.215a1.388 1.388 0 0 1-.586-.56c-.364.544-.925.817-1.687.817-.551 0-.996-.166-1.335-.498-.338-.331-.508-.759-.508-1.283 0-.621.23-1.096.692-1.424.46-.328 1.13-.492 2.01-.492h.398v-.136c0-.28-.056-.468-.167-.566-.112-.097-.325-.146-.64-.146-.167 0-.381.026-.643.078a6.67 6.67 0 0 0-.801.215l-.45-1.32a5.86 5.86 0 0 1 1.115-.324 5.87 5.87 0 0 1 1.094-.115c.88 0 1.519.169 1.916.508.398.338.597.856.597 1.555v1.926Zm-2.639.566a.686.686 0 0 0 .351-.094.843.843 0 0 0 .267-.241v-.827h-.22c-.293 0-.51.052-.649.157-.14.104-.21.265-.21.481 0 .16.042.288.126.383a.426.426 0 0 0 .335.141Zm6.263-.021c.523 0 .785-.506.785-1.519 0-.425-.028-.75-.084-.973-.055-.224-.13-.372-.225-.445a.57.57 0 0 0-.361-.11c-.293 0-.538.174-.733.523v2.136c.09.14.185.24.283.299.097.06.21.089.335.089Zm8.34-4.095c-.268-.293-.636-.44-1.104-.44-.335 0-.637.063-.906.189a2.666 2.666 0 0 0-.79.597l-.147-.576h-1.812v5.592h2.074v-3.738c.237-.37.471-.556.701-.556.105 0 .184.039.236.116.052.076.079.22.079.43v3.748h2.073v-4.126c0-.53-.134-.942-.403-1.236Zm6.07 3.55c0 .196.024.34.073.435a.47.47 0 0 0 .262.215l-.42 1.33c-.376-.028-.683-.1-.92-.215a1.387 1.387 0 0 1-.587-.56c-.363.544-.925.817-1.686.817-.552 0-.997-.166-1.335-.498-.339-.332-.508-.76-.508-1.283 0-.621.23-1.096.69-1.424.462-.328 1.132-.492 2.011-.492h.398v-.136c0-.28-.055-.468-.167-.566-.112-.097-.325-.146-.639-.146-.168 0-.382.026-.644.078a6.671 6.671 0 0 0-.801.215l-.45-1.32c.342-.14.713-.248 1.115-.324a5.87 5.87 0 0 1 1.094-.116c.88 0 1.519.17 1.917.508.398.339.597.857.597 1.556v1.926Zm-2.289.472a.686.686 0 0 1-.35.094.426.426 0 0 1-.336-.141.554.554 0 0 1-.125-.383c0-.216.07-.377.21-.481.139-.105.355-.157.648-.157h.22v.827a.846.846 0 0 1-.267.24Z"
				clipRule="evenodd"
			/>
		</g>
		<defs>
			<filter
				id="a"
				width={85.188}
				height={85.188}
				x={23.09}
				y={0.875}
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
			>
				<feFlood floodOpacity={0} result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy={9.969} />
				<feGaussianBlur stdDeviation={14.047} />
				<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
				<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_169_33827" />
				<feBlend
					in="SourceGraphic"
					in2="effect1_dropShadow_169_33827"
					result="shape"
				/>
			</filter>
		</defs>
	</svg>
);
export default ApnaViLogo;
